import type { TellentMember } from '@core/tellent-types';
import { TellentOrgAbilities } from '@core/tellent-types';

export const isSelf = ({ admin, member }: AbilitiesCheckPair) => admin.userGuid === member.userGuid;

export const canChangeMemberPermissions = (data: AbilitiesCheckPair) =>
  !isSelf(data) &&
  hasTellentAbility(data.admin) &&
  !data.member.owner &&
  data.member.status !== 'deactivated';

export const hasTellentAbility = (admin: TellentMember) =>
  admin.abilities.includes(TellentOrgAbilities.ManageTellent);

import type {
  AbilityGroupConfig,
  AbilityGroupViewModel,
  AbilityEditLevel,
  AbilitiesCheckPair,
} from './types';

export const describeGroup =
  (id: AbilityEditLevel, desc: AbilityGroupConfig) =>
  (data: AbilitiesCheckPair): AbilityGroupViewModel => ({
    id,
    canView: desc.canView(data),
    canEdit: desc.canEdit(data),
    match: desc.match(data),
    abilities: desc.abilities.map(abilityOrConfig =>
      typeof abilityOrConfig === 'string'
        ? {
            hidden: false,
            id: abilityOrConfig,
            getControlState: data => ({ value: true, disabled: false }),
          }
        : abilityOrConfig,
    ),
  });

export const describeAbility = (ability: TellentOrgAbilities, hidden = false) => ({
  id: ability,
  hidden,
  getControlState: ({ admin, member }: AbilitiesCheckPair) => ({
    value: member.abilities.includes(ability),
    disabled: !canChangeMemberPermissions({ admin, member }),
  }),
});

export const buildGroups = (
  vms: Array<ReturnType<typeof describeGroup>>,
  { admin, member }: AbilitiesCheckPair,
) => vms.map(vm => vm({ admin, member }));
